import React, { JSX } from "react";

import RenderCheckList from "./RenderCheckList";
import StatusLabel from "./StatusLabel";
import GlobalStyle from "../../styles/GlobalStyle";
import {
  scaleVertical,
  FontSizes,
  scaleHorizontal,
  scaleModerate,
} from "../../styles/responsive";
import { V2ReportStyle } from "../../styles/V2ReportStyle";
import { PALLETTE } from "../../utils/theme";
import { ReortLabels } from "../../utils/helpers/newReportHelper";
import { RightTickmarkSvg, SearchteethIconSvg } from "../../utils/Svgs";
import MultilineTextBox from "./MultilineTextBox";

// Type definitions for the sections
type typeSectionTypeProp =
  | "Neurological_Abnormal_Body_Tone_"
  | "Orthopedics_Spinal_Abnormalities_"
  | "Lymphatic_PLN_"
  | "Xray_"
  | "Urine_Test_"
  | "Stool_Test_"
  | "Blood_Test_"
  | "Ultrasound_"
  | "Deficiencies_Suspected_Vitamins_"
  | "Habits_";

const SectionRenderCheckList = ({
  title,
  section = [],
}: {
  title: string;
  section?: any[];
}) => {
  return (
    <div
      style={{
        ...V2ReportStyle.flexColumnCenter,
        gap: scaleVertical(4),
      }}
    >
      {title && (
        <span style={{ ...GlobalStyle.blackMediumText, fontSize: "2rem" }}>
          {title}
        </span>
      )}
      {section?.map((item, index) => (
        <div
          key={index}
          style={{
            ...V2ReportStyle.flexRowCenter,
            paddingLeft: scaleHorizontal(10),
            flex: 1,
            justifyContent: "space-between",
            display: "flex",
          }}
        >
          <div style={{ ...V2ReportStyle.flexRowCenter }}>
            <div
              style={{
                ...V2ReportStyle.flexRowCenter,
                gap: scaleHorizontal(5),
              }}
            >
              <div style={V2ReportStyle.point} />
              <span
                style={{
                  ...GlobalStyle.blackMediumText,
                  fontSize: "1.7rem",
                }}
              >
                {item?.title}
              </span>
            </div>
            <div
              style={{
                ...V2ReportStyle.checkBox,
                borderColor: item?.isChecked ? PALLETTE.orange : PALLETTE.gray,
                borderStyle: "solid",
              }}
            >
              {item?.isChecked && <RightTickmarkSvg />}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const SectionComplaintsCard = ({
  imageSource,
  topLefticon,
  title,
  suggestionText,
  data,
  remark,
  sections = [],
  label = "Normal",
}: {
  imageSource?: any;
  topLefticon?: JSX.Element | null;
  title?: string;
  suggestionText?: string;
  data: any;
  remark?: string;
  sections: typeSectionTypeProp[];
  label: any;
}) => {
  const ailmentKeys = Object.keys(data || {}).filter((key) => data[key]);

  const subData = sections.map((sectionKeyPrefix) => {
    const res = Object.entries(data)
      .filter(([key]) => sectionKeyPrefix && key.startsWith(sectionKeyPrefix))
      .map(([key, isChecked]) => ({
        title: ReortLabels[key],
        isChecked: isChecked,
      }));
    return {
      heading: ReortLabels[sectionKeyPrefix],
      section: res,
    };
  });

  const ClinicalExaminationData = Object.entries(data)
    .filter(([key]) => !sections.some((prefix) => key.startsWith(prefix)))
    .map(([key, isChecked]) => ({
      title: ReortLabels[key],
      isChecked: isChecked,
    }));

  return (
    <div style={{ ...V2ReportStyle.card, gap: scaleVertical(10) }}>
      <div
        style={{
          ...V2ReportStyle.flexRowCenter,
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ ...V2ReportStyle.flexRowCenter, gap: scaleHorizontal(2) }}
        >
          {topLefticon}
          <span style={{ ...GlobalStyle.blackBoldText, fontSize: "2.2rem" }}>
            {title}
          </span>
          {/* {label === "Need Attention" && (
            <AlertWave ailmentKeys={ailmentKeys} title={title} label={label} />
          )} */}
        </div>
        <StatusLabel lable={label} />
      </div>

      <div style={{ ...V2ReportStyle.flexRowCenter, gap: scaleHorizontal(10) }}>
        {imageSource && (
          <img
            src={imageSource}
            alt="Report"
            style={{
              width: scaleModerate(60),
              height: scaleModerate(60),
              objectFit: "contain",
            }}
          />
        )}
        <div
          style={{
            ...V2ReportStyle.card,
            backgroundColor: PALLETTE.grayOpaque,
            padding: scaleModerate(10),
            flex: 1,
            gap: scaleVertical(5),
          }}
        >
          {ClinicalExaminationData.map((item, index) => (
            <RenderCheckList
              key={index}
              {...item}
              title={item?.title}
              isChecked={item?.isChecked}
            />
          ))}
          {subData.map((item, index) => (
            <SectionRenderCheckList
              key={index}
              title={item.heading}
              section={item.section}
            />
          ))}
        </div>
      </div>

      {suggestionText && (
        <div style={{ ...V2ReportStyle.flexRowCenter }}>
          <span
            style={{
              ...GlobalStyle.blackMediumText,
              fontSize: "2rem",
            }}
          >
            {suggestionText}
          </span>
        </div>
      )}

      {remark && (
        <MultilineTextBox
          label="Doctor’s Remarks"
          icon={<SearchteethIconSvg />}
          description={remark}
        />
      )}
    </div>
  );
};

export default SectionComplaintsCard;
